const F = 'Roboto, sans-serif'

/**
 * «Доступно обновление» — показывается, когда на сервере лежит новая сборка, но
 * тихо перезагрузиться нельзя: человек заполняет поле или идёт сохранение
 * (см. useBuildVersion / decideUpdate). Сидит над TabBar, ввод не блокирует.
 *
 * Закрыть нельзя намеренно: смысл механизма — чтобы клиент не остался на старом
 * бандле (из-за этого баг #321 переоткрывали пять раз).
 */
export function UpdateBanner({ onApply }: { onApply: () => void }) {
  return (
    <div
      data-testid="update-banner"
      style={{
        position: 'fixed',
        // TabBar: bottom calc(14px + safe-area), height 64 → садимся над ним.
        bottom: 'calc(88px + env(safe-area-inset-bottom, 0px))',
        left: 12,
        right: 12,
        zIndex: 310,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        padding: '10px 12px',
        borderRadius: 14,
        background: 'rgba(28,45,65,0.96)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.22)',
        fontFamily: F,
      }}
    >
      <span style={{ fontSize: 13, fontWeight: 600, color: '#fff' }}>
        Доступно обновление
      </span>
      <button
        data-testid="update-banner-apply"
        onClick={onApply}
        style={{
          flexShrink: 0,
          border: 'none',
          borderRadius: 10,
          padding: '7px 14px',
          background: '#6C5CE7',
          color: '#fff',
          fontFamily: F,
          fontSize: 13,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Обновить
      </button>
    </div>
  )
}
